module.exports = __webpack_public_path__ + "media/images/home/cv_bg_sp-19df17281e62c8944a1d960613d9f41b.png";